import { render, staticRenderFns } from "./ClientsIndex.vue?vue&type=template&id=2963b672&"
import script from "./ClientsIndex.vue?vue&type=script&lang=js&"
export * from "./ClientsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports